import { createSlice } from '@reduxjs/toolkit';
import { translate } from '@/core/utils/translate';
import { googleLoginUser, loginUser } from '../application/loginUser';

// Auth state'i localStorage'dan yükleyen fonksiyon
const loadAuthState = () => {
  try {
    const storedState = localStorage.getItem('authState');
    if (storedState) {
      const parsedState = JSON.parse(storedState);
      // Ensure isAuthenticated is explicitly set when tokens exist
      if (parsedState.accessToken && parsedState.refreshToken) {
        parsedState.isAuthenticated = true;
        return parsedState;
      }
    }
    return null;
  } catch (error) {
    void error;
    return null;
  }
};

const initialState = loadAuthState() || {
  isAuthenticated: false,
  user: null,
  accessToken: null,
  refreshToken: null,
  status: null,
  error: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    logout: (state) => {
      Object.assign(state, {
        isAuthenticated: false,
        user: null,
        accessToken: null,
        refreshToken: null,
        status: null,
        error: null,
      });
      localStorage.removeItem('authState');
      const itemsToRemove = [
        'channelId',
        'channelName',
        'cmsId',
        'cmsName',
        'companyId',
        'selectBoxData',
        'selectedChannel',
      ];

      itemsToRemove.forEach((item) => {
        if (localStorage.getItem(item) !== null) {
          localStorage.removeItem(item);
        }
      });
    },
    // Add restoreState reducer
    restoreState: (state, action) => {
      return { ...state, ...action.payload, isAuthenticated: true };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginUser.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        const { access_token, refresh_token, user } = action.payload;

        Object.assign(state, {
          status: 'succeeded',
          isAuthenticated: true,
          user,
          accessToken: access_token,
          refreshToken: refresh_token,
          error: null,
        });

        localStorage.setItem(
          'authState',
          JSON.stringify({
            isAuthenticated: true,
            user,
            accessToken: access_token,
            refreshToken: refresh_token,
          })
        );
      })
      .addCase(loginUser.rejected, (state, action) => {
        Object.assign(state, {
          status: 'failed',
          isAuthenticated: false,
          user: null,
          accessToken: null,
          refreshToken: null,
          error: action.payload || translate('errors/api:login_failed'),
        });
      })
      .addCase(googleLoginUser.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(googleLoginUser.fulfilled, (state, action) => {
        const { access_token, refresh_token, user } = action.payload;

        Object.assign(state, {
          status: 'succeeded',
          isAuthenticated: true,
          user,
          accessToken: access_token,
          refreshToken: refresh_token,
          error: null,
        });

        localStorage.setItem(
          'authState',
          JSON.stringify({
            isAuthenticated: true,
            user,
            accessToken: access_token,
            refreshToken: refresh_token,
          })
        );
      })
      .addCase(googleLoginUser.rejected, (state, action) => {
        Object.assign(state, {
          status: 'failed',
          isAuthenticated: false,
          user: null,
          accessToken: null,
          refreshToken: null,
          error: action.payload || translate('errors/api:google_login_failed'),
        });
      });
  },
});

export const { logout, restoreState } = authSlice.actions;
export default authSlice.reducer;
